module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/card-corner-green-1ad50f3f1f9a805506c50308d3196240.svg";